import { formatMoneyUsd } from "../format"
import { TextCell } from "./text-cell"

type Props = {
  value: number | null | undefined
  currency?: string
  align?: "left" | "right" | "center"
}

export function MoneyCell({ value, currency = "USD", align = "right" }: Props) {
  return <TextCell value={formatMoneyUsd(value, currency)} align={align} mono />
}
